export const houseFloorsRoutes = [
  {
    path: '/admin/house-floors',
    name: 'house-floor-management',
    meta: { layout: 'dashboard' },
    component: () => import(/* webpackChunkName: "house-floors" */ './HouseFloorsView.vue'),
  },
];
